<template>
  <div class="container o-form-page">
    <o-working-overlay :working="working"></o-working-overlay>

    <o-section :level="0" :title="title" @click="enableDebug($event)">
      <item-form
        :form-state="formState"
        :item="item"
        :server-errors="serverErrors"
      ></item-form>
    </o-section>

    <o-action-buttons
      :create="create"
      :form-state="formState"
      :item="item"
      :show-create-and-new="true"
      @delete="doDeleteItem"
      @save="doSave"
      @saveAndClose="doSaveAndClose"
      @saveAndNew="doSaveAndNew"
    ></o-action-buttons>
  </div>
</template>

<script>
import {
  CreateFormPageMixin,
  CreateGroupPermissionMixin,
  UnsavedMixin,
} from "../../../../vue-ocom/mixins";
import ItemForm from "../components/ItemForm.vue";
import OActionButtons from "../../../../vue-ocom/components/forms/OActionButtons.vue";
import OSection from "../../../../vue-ocom/components/layout/OSection.vue";
import OWorkingOverlay from "../../../../vue-ocom/components/OWorkingOverlay.vue";
import { FetchCodeMixin } from "../../../../vue-ocom/mixins";

export default {
  mixins: [
    UnsavedMixin,
    CreateFormPageMixin("FormTemplate", "form_template"),
    CreateGroupPermissionMixin("FormTemplate"),
    FetchCodeMixin(["Group"]),
  ],
  components: {
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemForm,
  },
  methods: {
    OnBeforeSave(item) {
      var versions = item.versions || [];

      var lastIndex = versions.length - 1;

      if (lastIndex > -1) {
        // There is atleast 1 version here

        var last_version = versions[lastIndex];
        if (last_version._changed && last_version._usage_count > 0) {
          // The last Version was Changed AND there are existing Entries for thie Version so create NEW one.

          var date_of_change = new Date();

          var newVersion = {
            ...last_version,
            id: null,
            pk: null,
            _usage_count: 0,
            _changed: false,
            active_start_date: date_of_change,
            active_end_date: null,
          }; // copy the changed last version as the New version

          //Restore previous "original" version with End Date
          versions[lastIndex] = {
            ...this.original_item.versions[lastIndex],
            active_end_date: date_of_change,
          };

          versions.push(newVersion);

          this.$set(item, "versions", versions);
        }
      }

      return item;
    },
  },
  computed: {
    title() {
      if (this.create) {
        return "Create Form Template";
      }

      return "Edit Form Template";
    },
  },
};
</script>
